$(document).ready(function () {
  $('.banner_slider .banner_list').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  
   $(".reviews-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 761,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1120,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  });
  
  
});

// tabbed content
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.products-slider-section .product-slider').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  
  $('.products-slider-section .product-slider').slick('refresh');
  
});

$(document).on('click','.select-label', function () {
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
    }else{
      $('.dropdown').removeClass('active');
      $(this).parent().addClass('active');
    }
});
$(document).on('click','.dropdown-list li', function () {
    $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
    $(this).parents('.dropdown').removeClass('active');
    var variant_id = $(this).data('value');
    $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
});

// footer do not click btn
 const openBtn = document.getElementById('openPopup');
  const closeBtn = document.getElementById('closePopup');
  const popup = document.getElementById('popupOverlay');

  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    popup.classList.add('active');
  });

  closeBtn.addEventListener('click', () => {
    popup.classList.remove('active');
  });

  // Close when clicking outside the box
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.classList.remove('active');
    }
  });


// custom page limit
// document.addEventListener("DOMContentLoaded", function () {
//   // Find the wrapper
//   const wrapper = document.querySelector('.products-per-page-wrapper');
  
//   if (!wrapper) {
//     console.error('Wrapper not found');
//     return;
  
//     // Wait for items to be rendered (setTimeout before finding items)
//     setTimeout(function() {
      
//       // Find all .li items inside .bv_ul_inner
//       const items = wrapper.querySelectorAll('.bv_ul_inner .li');
//       if (items.length === 0) {
//         console.warn('No items found even after timeout. Check your HTML structure.');
//         return;
//       }
      
//       // Add click event to each item
//       items.forEach(function(item, index) {
//         item.addEventListener('click', function() {
//           // Find the span with class "text" inside this clicked item
//           const textSpan = this.querySelector('.text');
//           if (textSpan) {
//             // Get the text content
//             const limit = textSpan.textContent.trim();
            
//             const url = new URL(window.location.href);
//             url.searchParams.set("limit", limit); // set ?limit=xx
//             url.searchParams.delete("page");      // remove page param to reset to page 1
            
//             console.log('New URL:', url.toString());
//             window.location.href = url.toString();
//           }        
//         });
//       });
//     }, 500);
//   }  
// });

// document.addEventListener("DOMContentLoaded", function () {

//   const urlParams = new URLSearchParams(window.location.search);
//   const currentLimit = urlParams.get('limit');
//   const nativeSelect = document.getElementById('products-per-page');

//   function initBVSelect() {
//     // Try multiple ways to find the BV dropdown
//     let items = null;

//     // Method 1: Find via native select's data-random attribute
//     if (nativeSelect) {
//       const randomId = nativeSelect.getAttribute('data-random');
//       if (randomId) {
//         const ulInner = document.getElementById('ul_' + randomId);
//         if (ulInner) {
//           items = ulInner.querySelectorAll('.li');
//           console.log('Found via data-random:', randomId, 'Items:', items.length);
//         }
//       }
//     }

//     // Method 2: Fallback - find any .bv_ul_inner near products-per-page label
//     if (!items || items.length === 0) {
//       const wrapper = document.querySelector('.products-per-page-wrapper');
//       if (wrapper) {
//         const ulInner = wrapper.querySelector('.bv_ul_inner');
//         if (ulInner) {
//           items = ulInner.querySelectorAll('.li');
//           console.log('Found via wrapper:', items.length);
//         }
//       }
//     }

//     // Method 3: Fallback - find by checking all bv_ul_inner and match content
//     if (!items || items.length === 0) {
//       const allUlInners = document.querySelectorAll('.bv_ul_inner');
//       allUlInners.forEach(function(ul) {
//         const texts = ul.querySelectorAll('.text');
//         texts.forEach(function(t) {
//           if (t.textContent.trim() === '12' || t.textContent.trim() === '24') {
//             items = ul.querySelectorAll('.li');
//             console.log('Found via text content match:', items.length);
//           }
//         });
//       });
//     }

//     if (!items || items.length === 0) {
//       console.warn('BV select items not found, will retry...');
//       return false;
//     }

//     // Sync visual state on page load
//     if (currentLimit && nativeSelect) {
//       nativeSelect.value = currentLimit;

//       items.forEach(function (item) {
//         const textSpan = item.querySelector('.text');
//         if (!textSpan) return;
//         item.classList.remove('bv_selected');
//         if (textSpan.textContent.trim() === currentLimit) {
//           item.classList.add('bv_selected');

//           // Update the BV button display text
//           if (nativeSelect) {
//             const randomId = nativeSelect.getAttribute('data-random');
//             if (randomId) {
//               const mainDisplay = document.querySelector('#main_' + randomId + ' .sl_inner');
//               if (mainDisplay) mainDisplay.textContent = currentLimit;
//             }
//           }
//         }
//       });
//     }

//     // Attach click handlers
//     items.forEach(function (item) {
//       const textSpan = item.querySelector('.text');
//       if (!textSpan) return;

//       item.addEventListener('click', function () {
//         const limit = textSpan.textContent.trim();
//         if (!limit) return;

//         const url = new URL(window.location.href);
//         url.searchParams.set("limit", limit);
//         url.searchParams.delete("page");
//         window.location.href = url.toString();
//       });
//     });

//     console.log('BV Select initialized successfully');
//     return true;
//   }

//   // Retry logic — try every 300ms up to 10 times (3 seconds total)
//   let attempts = 0;
//   const maxAttempts = 10;

//   function tryInit() {
//     attempts++;
//     const success = initBVSelect();
//     if (!success && attempts < maxAttempts) {
//       console.log('Attempt ' + attempts + ' failed, retrying...');
//       setTimeout(tryInit, 300);
//     } else if (!success) {
//       console.error('Failed to initialize BV Select after ' + maxAttempts + ' attempts');
//     }
//   }

//   setTimeout(tryInit, 300);

// });

document.addEventListener("DOMContentLoaded", function () {

  const urlParams = new URLSearchParams(window.location.search);
  const currentLimit = urlParams.get('limit');
  const nativeSelect = document.getElementById('products-per-page');

  // Fix: Patch all load-more button hrefs with current limit on page load
  function patchLoadMoreButtons() {
    if (!currentLimit) return;
    const loadMoreButtons = document.querySelectorAll('#load-more-button[data-next], #load-more-button[data-prev]');
    loadMoreButtons.forEach(function (button) {
      const href = button.getAttribute('href');
      if (href) {
        const btnUrl = new URL(href, window.location.origin);
        btnUrl.searchParams.set('limit', currentLimit);
        button.setAttribute('href', btnUrl.toString());
      }
    });
  }

  // Patch immediately and after delays to catch late-rendered buttons
  patchLoadMoreButtons();
  setTimeout(patchLoadMoreButtons, 300);
  setTimeout(patchLoadMoreButtons, 800);

  // Re-patch whenever collectionLoadMore fires (after each load-more click)
  window.addEventListener('collectionLoadMore', function () {
    setTimeout(patchLoadMoreButtons, 100);
  });

  function initBVSelect() {
    let items = null;

    // Method 1: Find via native select's data-random attribute
    if (nativeSelect) {
      const randomId = nativeSelect.getAttribute('data-random');
      if (randomId) {
        const ulInner = document.getElementById('ul_' + randomId);
        if (ulInner) {
          items = ulInner.querySelectorAll('.li');
          console.log('Found via data-random:', randomId, 'Items:', items.length);
        }
      }
    }

    // Method 2: Fallback - find any .bv_ul_inner near products-per-page label
    if (!items || items.length === 0) {
      const wrapper = document.querySelector('.products-per-page-wrapper');
      if (wrapper) {
        const ulInner = wrapper.querySelector('.bv_ul_inner');
        if (ulInner) {
          items = ulInner.querySelectorAll('.li');
          console.log('Found via wrapper:', items.length);
        }
      }
    }

    // Method 3: Fallback - find by checking all bv_ul_inner and match content
    if (!items || items.length === 0) {
      const allUlInners = document.querySelectorAll('.bv_ul_inner');
      allUlInners.forEach(function (ul) {
        const texts = ul.querySelectorAll('.text');
        texts.forEach(function (t) {
          if (t.textContent.trim() === '12' || t.textContent.trim() === '24') {
            items = ul.querySelectorAll('.li');
            console.log('Found via text content match:', items.length);
          }
        });
      });
    }

    if (!items || items.length === 0) {
      console.warn('BV select items not found, will retry...');
      return false;
    }

    // Sync visual state on page load
    if (currentLimit && nativeSelect) {
      nativeSelect.value = currentLimit;

      items.forEach(function (item) {
        const textSpan = item.querySelector('.text');
        if (!textSpan) return;
        item.classList.remove('bv_selected');
        if (textSpan.textContent.trim() === currentLimit) {
          item.classList.add('bv_selected');

          // Update the BV button display text
          const randomId = nativeSelect.getAttribute('data-random');
          if (randomId) {
            const mainDisplay = document.querySelector('#main_' + randomId + ' .sl_inner');
            if (mainDisplay) mainDisplay.textContent = currentLimit;
          }
        }
      });
    }

    // Attach click handlers
    items.forEach(function (item) {
      const textSpan = item.querySelector('.text');
      if (!textSpan) return;

      item.addEventListener('click', function () {
        const limit = textSpan.textContent.trim();
        if (!limit) return;

        const url = new URL(window.location.href);
        url.searchParams.set("limit", limit);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });

    console.log('BV Select initialized successfully');
    return true;
  }

  // Retry logic — try every 300ms up to 10 times (3 seconds total)
  let attempts = 0;
  const maxAttempts = 10;

  function tryInit() {
    attempts++;
    const success = initBVSelect();
    if (!success && attempts < maxAttempts) {
      console.log('Attempt ' + attempts + ' failed, retrying...');
      setTimeout(tryInit, 300);
    } else if (!success) {
      console.error('Failed to initialize BV Select after ' + maxAttempts + ' attempts');
    }
  }

  setTimeout(tryInit, 300);

});

// PDP on variant show SKU, UPC sale badge
window.addEventListener("productVariants", function (evt) {
  // Access variant data from the event
  const currentVariantElement = document.querySelector('[data-current-variant]');
  const productInfoData       = document.querySelector('.product_info_data');
  const saleBadges            = document.querySelector('.pdp.sale_badges');
  
  if (currentVariantElement) {
    const currentVariantId = currentVariantElement.dataset.currentVariant;
    // Find the full variant object from window.variantDataMap
    const variant = window.variantDataMap[currentVariantId];
    if (variant) {
      const mainPrice = variant.price;
      const comparePrice = variant.compare_price;
      if (comparePrice > mainPrice) {
        saleBadges.querySelector('.sale-text').classList.remove('hidden')
      } else {
        saleBadges.querySelector('.sale-text').classList.add('hidden')
      }
      if (variant.quantity == 1) {
        saleBadges.querySelector('.last-one').classList.remove('hidden')
      } else {
        saleBadges.querySelector('.last-one').classList.add('hidden')
      }

      productInfoData.querySelector('.sku').innerHTML = variant.sku;
      productInfoData.querySelector('.upc').innerHTML = variant.barcode;
    }
  }
});